import { useContext } from 'react';
import clsx from 'clsx';

import WorkOrderDetailMap from '@atom/components/common/workOrderDetail/workOrderDetailMap/WorkOrderDetailMap';
import WorkOrderPreviewContext, {
  ExpandedInfo,
} from '@atom/components/workOrderPreview/WorkOrderPreviewContext';
import { Icon, IconButton } from '@atom/mui';
import { ExpandLessIcon, ExpandMoreIcon } from '@atom/mui/icons';
import { toggleFromSet } from '@atom/utilities/setUtilities';

import classes from './infoView.module.css';

const LocationSection = () => {
  const { workOrderDetail, refetch, loading, expandedInfo, setExpandedInfo } =
    useContext(WorkOrderPreviewContext);

  const toggleSection = () => {
    setExpandedInfo(toggleFromSet(expandedInfo, ExpandedInfo.LOCATION));
  };

  const icon = expandedInfo.has(ExpandedInfo.LOCATION)
    ? ExpandLessIcon
    : ExpandMoreIcon;

  return (
    <>
      <div className={classes.sectionHeader}>
        <div className={classes.sectionTitle}>Location</div>
        <IconButton onClick={toggleSection}>
          <Icon icon={icon} />
        </IconButton>
      </div>
      {expandedInfo.has(ExpandedInfo.LOCATION) && (
        <div className={clsx(classes.sectionContent, classes.location)}>
          <WorkOrderDetailMap
            workOrderDetail={workOrderDetail}
            refetch={refetch}
            loading={loading}
          />
        </div>
      )}
    </>
  );
};

export default LocationSection;
